import LocalisationDto from "../interfaces/dtos/localisation-dto.ts";

class Localisation { 
    id: number;
    
    parentId?: number;
    
    name: string;
    
    level: number;
    
    latitude: number;
    
    longitude: number;
    
    constructor(dto: LocalisationDto) {
        this.id = dto.localisationId;
        this.parentId = dto.parentId;
        this.name = dto.name;
        
        this.level = dto.level;
        this.latitude = dto.latitude;
        this.longitude = dto.longitude;
    }
}

export default Localisation;